<template>
  <!-- 云诊病案分析详情 -->
  <Modal title="云诊病案分析详情" :value="value" width="90%" @on-cancel="close">
    <div class="case-analysis">
      <div v-if="bhItem.type">
        <yzAanlysisResult v-model="showYz" :info="bhItem.symptomEtiologyDialecticalAllVO"></yzAanlysisResult>
      </div>
      <empty v-else></empty>
    </div>
    <template #footer>
      <span>
        <Button @click="close">关闭</Button>
      </span>
    </template>
  </Modal>
</template>

<script>
import request from "@/utils/request";
import yzAanlysisResult from "@/com/yzAnalysisResult/index.vue";
export default {
  name: "yzDetail",
  components: {
    yzAanlysisResult,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    taskInfo: {
      type: Object,
      default: () => { },
    },
    patientCode: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) {
        this.getData();
      }
    },
  },
  data() {
    return {
      showYz: false,
      bhItem: {},
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    getData() {
      let obj = {
        id: this.taskInfo.id,
        type: this.taskInfo.type,
        taskId: this.taskInfo.taskId,
        patientCode: this.patientCode, //	患者编码
      };
      request.post("/saasbaihui/reviewAnalysisResult", obj).then((res) => {
        this.bhItem = res.result;
        this.showYz = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.case-analysis {
  width: 100%;
  height: 70vh;
  overflow-y: auto;
}

.row-group {
  display: flex;

  .list2-item {
    padding-right: 20px;
  }
}

.box-card {
  :deep {
    .el-card__body {}

    .el-card__header {
      padding: 0px 15px;
      height: 50px;

      .card-header {
        height: 100%;
      }
    }

    .create-table-page .tabs-and-tab {
      padding: 0;
      box-shadow: none;
    }
  }
}

.visit-record {
  width: 100%;
  height: calc(100% - 50px);
  overflow: auto;
  line-height: 2em;

  .label {
    opacity: 0.7;
  }

  .list2 {
    padding: 15px;
    background: var(--el-bg-color-page);
    border-radius: 10px;
    margin-bottom: 15px;
  }

  .title {
    opacity: 0.7;
  }

  .list2-item2 {
    font-size: 13px;
    opacity: 0.6;

    .value {
      padding-right: 15px;
    }
  }

  .row {
    margin-bottom: 10px;
  }

  .pic {
    display: inline-block;
    width: 100px;
    height: 100px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin: 0 10px 10px 0;
    padding: 2px;
    text-align: center;
    line-height: 100px;

    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }

  .cf {
    position: relative;

    .ts {
      position: absolute;
      right: 40px;
      top: 0;
      color: #f00;
      font-size: 20px;

      i {
        font-size: 30px;
        font-style: inherit;
      }
    }
  }

  .value {}
}

:deep {
  table {
    // width: 100% !important;
  }

  th,
  td,
  table {
    border-collapse: collapse;
    border: 1px solid var(--el-border-color-light) !important;
  }
}

.Page {
  padding-top: 20px;
}
</style>
